export default "__VITE_ASSET__289e4513__"